import { Fragment, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../Context/UserContext";

const GuestLayout = ({ element: Element }) => {
  const { user, token } = useContext(AuthContext);

  if (token) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Element />
    </Fragment>
  );
}
export default GuestLayout;
